// @flow
import React, { useEffect } from 'react';
import { dataLayer } from '@finect/front-gtm';
import { FinectLogoPlus } from '@finect/tabular-components/FinectLogoPlus';
import { getPlusItem } from '../../../utils/ga4Plus';
import {
  ModalOverlay,
  Card,
  CardHeader,
  SavingsBadge,
  LogoWrapper,
  CardTitle,
  CardBody,
  Description,
  PriceRow,
  PriceOriginal,
  PriceCurrent,
  Actions,
  PrimaryLink,
  SecondaryLink
} from './partials';

type Props = {
  buyUrl: string,
  prices?: {
    monthly?: {
      price?: number,
      original?: number
    },
    yearly?: {
      price?: number,
      original?: number
    }
  }
};

export const PlusUpgradeModal = ({ buyUrl, prices }: Props) => {
  const monthlyPrice = prices?.monthly?.price;
  const monthlyOriginal = prices?.monthly?.original;
  const yearlyPrice = prices?.yearly?.price;
  const yearlyOriginal = prices?.yearly?.original;

  useEffect(() => {
    dataLayer({
      id: 'PlusViewUpgradeModal',
      type: 'view_upgrade_modal',
      params: {
        items: [
          getPlusItem('monthly', monthlyPrice, monthlyOriginal),
          getPlusItem('yearly', yearlyPrice, yearlyOriginal)
        ]
      }
    });
  }, []);

  return (
    <ModalOverlay>
      <Card>
        <CardHeader>
          <SavingsBadge>¡Ahorra más!</SavingsBadge>

          <LogoWrapper>
            <FinectLogoPlus white style={{ height: '28px' }} />
          </LogoWrapper>

          <CardTitle>¿Prefieres plan Anual?</CardTitle>
        </CardHeader>

        <CardBody>
          <Description>
            Con la suscripción anual disfrutas de <strong>todos los beneficios de Finect Plus</strong> pagando menos a
            lo largo del año.
          </Description>

          {yearlyOriginal && yearlyPrice && (
            <PriceRow>
              <PriceOriginal>{yearlyOriginal.toString().replace('.', ',')}€/año</PriceOriginal>
              <PriceCurrent>{yearlyPrice.toString().replace('.', ',')}€/año</PriceCurrent>
            </PriceRow>
          )}

          <Actions>
            <PrimaryLink
              data-fi-event="plus-btnUpgradeAnual"
              onClick={() => {
                dataLayer({
                  id: 'PlusAddToCart',
                  type: 'add_to_cart',
                  params: {
                    value: yearlyPrice,
                    items: [getPlusItem('yearly', yearlyPrice, yearlyOriginal)]
                  }
                });
                window.location.href = `${buyUrl}?plan=yearly`;
              }}
            >
              Sí, quiero el plan Anual 🎉
            </PrimaryLink>

            <SecondaryLink
              data-fi-event="plus-btnUpgradeMensual"
              onClick={() => {
                dataLayer({
                  id: 'PlusAddToCart',
                  type: 'add_to_cart',
                  params: {
                    value: monthlyPrice,
                    items: [getPlusItem('monthly', monthlyPrice, monthlyOriginal)]
                  }
                });
                window.location.href = `${buyUrl}?plan=monthly`;
              }}
            >
              No, continuar con el plan Mensual
            </SecondaryLink>
          </Actions>
        </CardBody>
      </Card>
    </ModalOverlay>
  );
};
